import AlertDialog from "../../../components/Common/Dialog";
import SnackBarUtils from "../../../utils/SnackBarUtils";
import {
  aprobar,
  pausar,
  reanudar,
  rechazar,
} from "../services/productos.service";
import { IProducto, IRubro } from "../types/producto";
import { useContext, useState } from "react";
import TableProducto from "./Table/TableProducto";
import CardProducto from "./Card/CardProducto";
import { ProductosAdminContext } from "../context/productos.context";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material";

interface ProductoProps {
  producto: IProducto;
  rubros: IRubro[];
  loadingRubros: boolean;
}

export interface ProductoWProps {
  producto: IProducto;
  isSelected: boolean;
  setIsSelected: (value: boolean) => void;
  changingEstado: boolean;
  rubros: IRubro[];
  loadingRubros: boolean;
  isDefinitivelyDeleting?: boolean;
  cambiarRubro: (idRubro: number, nombreAnalytics: string) => Promise<void>;
}

const Producto = ({ producto, rubros, loadingRubros }: ProductoProps) => {
  const { actions } = useContext(ProductosAdminContext);
  const { handleChangeEstado, handleChangeRubro, borrarProducto } = actions;
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [changingEstado, setIsChangingEstado] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [isDefinitivelyDeleting, setIsDefinitivelyDeleting] =
    useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [dialogContent, setDialogContent] = useState<string>("");
  const [estadoCambiandoA, setEstadoCambiandoA] = useState<string>("");

  const cambiarEstado = async (funcion: Function) => {
    try {
      setIsChangingEstado(true);
      await handleChangeEstado(producto.idProducto, funcion, estadoCambiandoA);
      setIsChangingEstado(false);
      SnackBarUtils.success("Estado actualizado");
    } catch (e) {
      console.log(e);
    }
  };

  const cambiarRubro = async (idRubro: number, nombreAnalytics: string) => {
    try {
      await handleChangeRubro(producto.idProducto, idRubro, nombreAnalytics);
      SnackBarUtils.success("Rubro actualizado");
      setIsSelected(false);
    } catch (e) {
      console.log(e);
    }
  };

  const borrar = async () => {
    try {
      await borrarProducto(producto.idProducto);
      setIsDeleting(false);
      SnackBarUtils.success("Producto eliminado");
    } catch (e) {
      console.log(e);
    }
  };

  producto.aprobar = () => {
    setDialogContent("Se está por APROBAR el producto. ¿Deseas continuar?");
    setOpen(true);
    setEstadoCambiandoA("Aprobado");
  };

  producto.rechazar = () => {
    setDialogContent("Se está por RECHAZAR el producto. ¿Deseas continuar?");
    setOpen(true);
    setEstadoCambiandoA("Rechazado");
  };

  producto.pausar = () => {
    setDialogContent("Se está por PAUSAR el producto. ¿Deseas continuar?");
    setOpen(true);
    setEstadoCambiandoA("Pausado");
  };

  producto.reanudar = () => {
    setDialogContent("Se está por REANUDAR el producto. ¿Deseas continuar?");
    setOpen(true);
    setEstadoCambiandoA("Reanudado");
  };

  producto.borrar = () => {
    setDialogContent(
      "¿Deseas eliminar el producto? Esta acción no se puede deshacer"
    );
    setOpen(true);
    setIsDeleting(true);
  };

  const onConfirm = async () => {
    if (isDeleting) {
      setIsDefinitivelyDeleting(true);
      await borrar();
      setIsDefinitivelyDeleting(false);
    } else {
      await cambiarEstado(
        estadoCambiandoA === "Aprobado"
          ? aprobar
          : estadoCambiandoA === "Rechazado"
          ? rechazar
          : estadoCambiandoA === "Pausado"
          ? pausar
          : reanudar
      );
    }
    setOpen(false);
  };

  return (
    <>
      <AlertDialog
        title={
          isDefinitivelyDeleting
            ? "Eliminando"
            : isDeleting
            ? "Eliminar Producto"
            : estadoCambiandoA !== ""
            ? "Cambiar Estado"
            : "Confirmar"
        }
        onConfirm={onConfirm}
        onCancel={() => setOpen(false)}
        open={open}
        content={dialogContent}
        agreeColor={isDeleting ? "error" : "success"}
        disabled={changingEstado || isDefinitivelyDeleting}
        agreeText={
          changingEstado || isDefinitivelyDeleting ? "Espera" : "Confirmar"
        }
        disagreeText="Cancelar"
      />
      {isFullScreen ? (
        <CardProducto
          rubros={rubros}
          loadingRubros={loadingRubros}
          cambiarRubro={cambiarRubro}
          isSelected={isSelected}
          setIsSelected={setIsSelected}
          producto={producto}
          changingEstado={changingEstado}
          isDefinitivelyDeleting={isDefinitivelyDeleting}
        />
      ) : (
        <TableProducto
          rubros={rubros}
          loadingRubros={loadingRubros}
          cambiarRubro={cambiarRubro}
          isSelected={isSelected}
          setIsSelected={setIsSelected}
          producto={producto}
          changingEstado={changingEstado}
          isDefinitivelyDeleting={isDefinitivelyDeleting}
        />
      )}
    </>
  );
};

export default Producto;
